import { el } from "date-fns/locale";
import DwLogutil from "../../Utils/DwLogutil";
import { useAppSelector } from "../../hooks";
import { flowType } from "../../SharedContextStore/slices/user";

const logReg_Dwlogs_APIS = {
  ACCOUNT_DETAILS_SECURE_API: {
    success: "Account details secure API success",
    failed: "Account details secure API failed",
  },
  ACCOUNT_DETAILS_CUST_ID_API: {
    success: "Account details with customerID API success",
    failed: "Account details with customerID API failed",
  },
  ACCOUNT_DETAILS_BAN_AND_ADDRESS_ID_API: {
    success: "Account details with BAN and addressId API success",
    failed: "Account details with BAN and addressId API failed",
  },
  IAM_API: {
    success: "IAM API success",
    failed: "IAM API failed",
  },
  AZINFO_API: {
    success: "azinfo API success",
    failed: "azinfo API failed",
  },
  REGISTRATION_API: {
    success: "Registration API success",
    failed: "Registration API failed",
  },
  RESEND_OTP_API: {
    success: "Resent OTP API success",
    failed: "Resent OTP API failed",
  },
  SET_PASSWORD_API: {
    success: "Set password API success",
    failed: "Set password API failed",
  },
  FORGET_PASSWORD_API: {
    success: "Forget password API success",
    failed: "Forget password API failed",
  },
  FORGET_PASSWORD_RESEND_OTP_API: {
    success: "Foget password resend OTP API success",
    failed: "Foget password resend OTP API failed",
  },
  FORGET_USERNAME_API: {
    success: "Foget username API success",
    failed: "Foget username API failed",
  },
  LOGIN_API: {
    success: "Login/token API success",
    failed: "Login/token API failed",
  },
  OLD_PASS_CHECKED_API: {
    success: "Old password not matched with new password success",
    failed: "Old password is matched with new password failed",
  },
  VALIDATE_OTP_API: {
    success: "Validate-otp API success",
    failed: "Validate-otp API failed",
  },
  ENCRIPTION_API: {
    success: "Ency API success",
    failed: "Ency API failed",
  },
  DECRIPTION_API: {
    success: "Unency API success",
    failed: "Unency API failed",
  },
  RECAPTCHA_API: {
    success: "Recaptcha API success",
    failed: "Recaptcha API failed",
  },
  ACCOUNT_LOCK_API: {
    success: "Account lock API success",
    failed: "Account lock API failed",
  },
  ACCOUNT_UNLOCK_API: {
    success: "Account unlock API success",
    failed: "Account unlock API failed",
  },
  GET_ACCOUNT_DETAILS_BY_FILTER: {
    success: "Get Account Details ByFilters API success",
    failed: "Get Account Details ByFilters API failed",
  },
};

const logRegNormalStepNames = {
  login: {
    attempts: "Login Attempted",
    success: "Login Success",
    failed: "Login Failed",
  },
  forget_username: {
    attempts: "Forgot Username Attempted",
    success: "Forgot Username Success",
    failed: "Forgot Username Failed",
  },
  silent_login: {
    attempts: "Silent login attempted",
    success: "Silent login Success",
    failed: "Silent login Failed",
  },
  silent_registration: {
    attempts: "Silent registration attempted",
    success: "Silent registration Success",
    failed: "Silent registration Failed",
  },
  forget_password: {
    attempts: "Forgot Password Attempted",
    success: "Forgot Password Success",
    failed: "Forgot Password Failed",
  },
  registration: {
    attempts: "Registration attempted",
    success: "Registration Success",
    failed: "Registration Failed",
  },
  account_lock: {
    attempts: "Account-lock attempted",
    success: "Account Unlocked Success",
    failed: "Account-lock Failed",
  },
  login_with_recaptcha: { //  having only 3 step
    attempts: "Login re-captcha attempted",
    success: "Login re-captcha Success",
    failed: "Login re-captcha Failed",
  },
  set_password_first_time: {
    attempts: "Set-password first time attempted",
    success: "Set-password first time Success",
    failed: "Set-password first time Failed",
  },
  set_password_first_time_with_catpcha: { // 3 with set-password
    attempts: "Set-password first time re-captcha attempted",
    success: "Set-password first time re-captcha Success",
    failed: "Set-password first time re-captcha Failed",
  },
};

export type logReg_APIS_Names = keyof typeof logReg_Dwlogs_APIS;
export type logRegStepNames = keyof typeof logRegNormalStepNames;

type parameterType = {
  fromAPI: Boolean;
  API_StepName?: logReg_APIS_Names;
  stepName?: logRegStepNames;
  stepNameType?: keyof typeof logRegNormalStepNames.login;
  error?: string;
  email: string;
  flowType?: keyof typeof flowType
};

type checkFlowAndFinishFLowProps = {
    isFailed: boolean,
    failedReson: string,
    email: string,
    screenNo: number,
}

const flowTypeNameForLooker = {
  loginFlow: "loginFlow",
  forget_username: "Forget username",
  silent_login: "Silent login",
  silent_registration: "Silent registration",
  forget_password: "Forget password",
  registration: "Registration sign-up",
  account_lock: "Account-lock",
  login_with_recaptcha: "Recaptcha-login",
  set_password_first_time: "Set-password email-link",
  set_password_first_time_with_catpcha: "Reacaptcha set-password email-link"
}

/* useLogRegDwlogs function required parameter
    fromAPI
    email

API dwlogs want to push then required parameter is 
    API_StepName
    error if applicable

normal logreg DWlogs want to push required parameter is 
    stepName
    stepNameType
    error if applicable  */

const useLogRegDwlogs = () => {
  const userFLowType = useAppSelector((state) => state?.user?.flowType);

  const logRegDwLogs = (props: parameterType) => {
    const { fromAPI, stepName, error, API_StepName, email, stepNameType, flowType: prosFlowType } =
      props;
    if (flowType[userFLowType] || prosFlowType) {
      if (fromAPI) {
        if (!error && API_StepName) {
          DwLogutil({
            stepName: logReg_Dwlogs_APIS[API_StepName]?.success,
            email: email,
            flowType: flowTypeNameForLooker[prosFlowType || flowType[userFLowType] as keyof typeof flowTypeNameForLooker]
          });
        } else if (API_StepName) {
          DwLogutil({
            stepName: logReg_Dwlogs_APIS[API_StepName]?.failed,
            error: error,
            email: email,
            flowType: flowTypeNameForLooker[prosFlowType || flowType[userFLowType] as keyof typeof flowTypeNameForLooker]
          });
        }
      } else if (stepName && stepNameType) {
        DwLogutil({
          stepName: logRegNormalStepNames[stepName][stepNameType],
          email: email,
          error: error,
          flowType: flowTypeNameForLooker[prosFlowType || flowType[userFLowType] as keyof typeof flowTypeNameForLooker]
        });
      } else {
        console.log(
          `Missing Dwlogs here flow is ${flowType[userFLowType]} and props is ${props}`,
          "background-color: #FFA500; color: #000"
        );
      }
    } else {
      console.log(
        `Missing Dwlogs here flow is ${flowType[userFLowType]} and props is ${props}`,
        "background-color: #FFA500; color: #000"
      );
    }
  };

  const dwlogsCustomFunc = (props: checkFlowAndFinishFLowProps, objectKeyName: keyof typeof logRegNormalStepNames) => {
    const {isFailed, failedReson = "", email} = props;
    if(!isFailed) {
        DwLogutil({
            stepName: logRegNormalStepNames[objectKeyName]?.success,
            email: email,
            flowType: flowTypeNameForLooker[flowType[userFLowType] as keyof typeof flowTypeNameForLooker]
        });
    } else {
        DwLogutil({
            stepName: logRegNormalStepNames?.silent_login?.failed,
            email: email,
            error: failedReson,
            flowType: flowTypeNameForLooker[flowType[userFLowType] as keyof typeof flowTypeNameForLooker]
        });
    }
  }

  const checkFlowAndFinishFlow = (props: checkFlowAndFinishFLowProps) => {
    const { screenNo } = props;
    switch (flowType[userFLowType]) {
      case (flowType[flowType.silent_login]):
        if(screenNo === 4) {
            dwlogsCustomFunc(props, "silent_login");
        } else {
            console.log(`Not able complete the flow the ${flowType[userFLowType]}`,"background-color: #FFA500; color: #000");
        }
        break;
      case (flowType[flowType.silent_registration]):
        if(screenNo === 4) {
            dwlogsCustomFunc(props, "silent_registration");
        } else {
            console.log(`Not able complete the flow the ${flowType[userFLowType]}`,"background-color: #FFA500; color: #000");
        }
        break;
      case (flowType[flowType.forget_password]):
        if(screenNo === 4) {
            dwlogsCustomFunc(props, "forget_password");
        } else {
            console.log(`Not able complete the flow the ${flowType[userFLowType]}`,"background-color: #FFA500; color: #000");
        }
        break;
      case (flowType[flowType.registration]):
        if(screenNo === 4) {
            dwlogsCustomFunc(props, "registration");
        } else {
            console.log(`Not able complete the flow the ${flowType[userFLowType]}`,"background-color: #FFA500; color: #000");
        }
        break;
      case (flowType[flowType.account_lock]):
        if(screenNo === 4) {
            dwlogsCustomFunc(props, "account_lock");
        } else {
            console.log(`Not able complete the flow the ${flowType[userFLowType]}`,"background-color: #FFA500; color: #000");
        }
        break;
      case (flowType[flowType.login_with_recaptcha]):
        if(screenNo === 3) {
            dwlogsCustomFunc(props, "login_with_recaptcha");
        } else {
            console.log(`Not able complete the flow the ${flowType[userFLowType]}`,"background-color: #FFA500; color: #000");
        }
        break;
      case (flowType[flowType.set_password_first_time]):
        if(screenNo === 1) {
            dwlogsCustomFunc(props, "set_password_first_time");
        } else {
            console.log(`Not able complete the flow the ${flowType[userFLowType]}`,"background-color: #FFA500; color: #000");
        }
        break;
      case (flowType[flowType.set_password_first_time_with_catpcha]):
        if(screenNo === 4) {
            dwlogsCustomFunc(props, "set_password_first_time_with_catpcha");
        } else {
            console.log(`Not able complete the flow the ${flowType[userFLowType]}`,"background-color: #FFA500; color: #000");
        }
        break;
      default:
        console.log(`Not able complete the flow the ${flowType[userFLowType]}`,
        "background-color: #FFA500; color: #000");
        break;
    }
  }

  return {logRegDwLogs, checkFlowAndFinishFlow};
};

export default useLogRegDwlogs;